module.exports = __webpack_public_path__ + "img/checkmark_white.ccb6ad3a.svg";